var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSizeTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.17 54.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.1,54.32c-1.16,0-2.1-.94-2.1-2.1V2.1C0,.94.94,0,2.1,0h22.28c.78,0,1.49.43,1.85,1.11,1.06,2.01,2.32,3.91,3.73,5.67,2.39,2.96,4.26,4.34,6.08,5.67,1.7,1.25,3.3,2.42,4.79,4.58,3.21,4.64,4.97,12.62,1.25,19.18-2.85,5.03-8.32,8.31-14.64,8.78l-.39.03v7.2c0,1.16-.94,2.1-2.1,2.1H2.1ZM22.85,50.12v-4.82l-.48.07c-.39.05-.78.08-1.16.08-2.51,0-4.86-1.13-6.29-3.03-2.08-2.75-2.38-7.43.77-10.19,1.27-1.11,2.86-1.7,4.59-1.7,2.08,0,4.18.85,5.61,2.26,1.89,1.87,2.65,4.61,2.04,7.34l-.14.61.62-.1c4.36-.69,8.11-3.12,10.03-6.51,2.83-4.99,1.44-11.13-1.05-14.73-1.09-1.58-2.24-2.42-3.82-3.58-1.85-1.36-4.14-3.04-6.87-6.43-1.26-1.57-2.42-3.25-3.43-5l-.12-.21H4.19v45.93h18.65ZM20.32,34.73c-.73,0-1.38.23-1.87.67-1.29,1.13-1.14,3.25-.19,4.51.65.85,1.74,1.36,2.93,1.36.63,0,1.26-.14,1.82-.41l.11-.05.07-.11c1.08-1.58.97-3.7-.26-4.91-.66-.65-1.66-1.06-2.62-1.06Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeTest);
export default __webpack_public_path__ + "static/media/size_test.7d30e1a77c45a47a3ee9a75f781d520c.svg";
export { ForwardRef as ReactComponent };